<template>
	<div class='editData'>
		<el-form
			:model="user"
			:rules="rules"
			label-position="left"
			ref="ruleForm"
			label-width="100px"
			class="demo-ruleForm"
		>
			<el-form-item
				label="头像"
				prop="headImg"
			>
				<img
					@click="$refs.file.click()"
					style="width: 60px; height: 60px; border-radius: 50%; cursor: pointer;"
					:src="user.headImg || require('@/assets/images/user.png')"
					alt=""
				>
			</el-form-item>
			<el-form-item
				label="昵称"
				prop="nickName"
			>
				<el-input v-model="user.nickName"></el-input>
			</el-form-item>
			<el-form-item label="出生日期">
				<el-form-item prop="birthday">
					<el-date-picker
						type="date"
						placeholder="选择日期"
						v-model="user.birthday"
						style="width: 100%;"
					></el-date-picker>
				</el-form-item>
			</el-form-item>
			<el-form-item
				label="性别"
				prop="sex"
			>
				<el-radio-group v-model="user.sex">
					<el-radio :label="0">男</el-radio>
					<el-radio :label="1">女</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item
				label="个性签名"
				prop="signature"
			>
				<el-input
					type="textarea"
					:autosize="{ minRows:5, maxRows: 5}"
					maxlength="50"
					v-model="user.signature"
				></el-input>
			</el-form-item>
			<el-form-item>
				<el-button
					type="primary"
					@click="submitForm('ruleForm')"
				>保存</el-button>
				<el-button @click="resetForm('ruleForm')">重置</el-button>
			</el-form-item>
		</el-form>

		<!-- 上传头像 -->
		<input
			type="file"
			accept="image/*"
			style="display: none"
			@change="headImgUpload"
			ref="file"
		/>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { userInfo, ossUpload, modifyResume } from "api/professionServer";
export default {
  name: "editData",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      user: {},
      rules: {
        nickName: [
          { required: true, message: "请输入昵称", trigger: "blur" },
          { min: 1, max: 5, message: "长度在 1 到 5 个字符", trigger: "blur" },
        ],
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    async getuserInfo() {
      const res = await userInfo();
      if (res.code != 200) return;

      this.user = res.data;
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await modifyResume(this.user);
          if (res.code != 200) return;
          this.$message.success("保存成功");
          this.$bus.$emit("getuserinfo");
        } else {
          return false;
        }
      });
    },

    resetForm() {
      this.getuserInfo();
    },

    async headImgUpload(e) {
      let file = e.target.files[0];
      let form = new FormData();
      form.append("file", file);
      form.append("file_name", file.name);
      const res = await ossUpload(form);
      if (res.code == 200) {
        this.user.headImg = res.data;
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getuserInfo();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.editData {
  height: 100%;
  overflow: auto;
  padding: 30px;
  box-sizing: border-box;
}
</style>